import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "@rocketseat/unform";
import { cpfMask, regexEmail, regexWhithoutSpace } from "../../../utils";
import { isCPFValid } from "../../../utils/validator";
import { CircularProgress } from "@material-ui/core";
import {
	onboardingGogogoRequest,
	setVerificatedEmailDuplicity,
	updateOnboardFieldRequest,
	verifyDuplicityEmailRequest,
} from "../../../store/modules/register/actions";
import {
	Container,
	ContainerPassword,
	ContainerRequirements,
	Content,
	FormGroupInput,
	FormGroupLine,
	Group,
	InputText,
	Label,
	Main,
	MessageError,
	PasswordEye,
	SubmitButton,
	Title,
} from "./styles";
import HttpService from "../../../services/HttpService";
import history from "../../../services/history";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import OnboardStep from "../../../pages/OnboardStep";
import alertIcon from "../../../assets/alert-outline.svg";
import checkIcon from "../../../assets/check-icon.svg";
import moment from "moment";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { userRegistered } from "../../../store/modules/onboardSimple/actions";
import RecaptchaInvisible from "../../Recaptcha/RecaptchaInvisible";
import { useAdjust } from "../../../hook/useAdjust";
import { ID_TERM_TRADEMAP } from "../../../utils/constants";

export default function FormState(props) {
	const { duplicityEmail, loading, isTermAccepted, resUpdateOnboardField } = useSelector(
		(state) => state.register
	);
	const { isUserRegistered } = useSelector((state) => state.onboardSimple);
	const dispatch = useDispatch();

	const { adid } = useAdjust();

	const [email, setEmail] = useState("");
	const [vlDocument, setVlDocument] = useState("");
	const [nome, setNome] = useState("");
	const [nameError, setNameError] = useState("");
	const [dataNascimento, setDataNascimento] = useState("");
	const [senha, setSenha] = useState("");
	const [confirmaSenha, setConfirmaSenha] = useState("");

	const [passSize, setPassSize] = useState(false);
	const [passNum, setPassNum] = useState(false);
	const [passUpper, setPassUpper] = useState(false);
	const [passLow, setPassLow] = useState(false);
	const [caracterSpecial, setCaracterSpecial] = useState(false);
	const [sequentialPassword, setSequentialPassword] = useState(false);

	const [inputEmailValid, setInputEmailValid] = useState(undefined);
	const [inputCpfValid, setInputCpfValid] = useState(undefined);
	const [inputNomeValid, setInputNomeValid] = useState(undefined);
	const [inputDataNascimentoValid, setInputDataNascimentoValid] = useState(undefined);
	const [birthdayError, setBirthdayError] = useState("");
	const [inputConfirmaSenhaValid, setInputConfirmaSenhaValid] = useState(undefined);
	const [passwordValid, setPasswordValid] = useState(undefined);
	const [messsageErrorEmail, setMessageErrorEmail] = useState("");
	const [isEqualsEmail, setIsEqualsEmail] = useState(undefined);
	const [disableInput, setDisableInput] = useState(false);

	const [hidePassword, setHidePassword] = useState(true);
	const [hidePasswordConfirmed, setHidePasswordConfirmed] = useState(true);
	const [dataForm, setDataForm] = useState({});
	const [editable, setEditable] = useState({});
	const [emailFieldIsEdited, setEmailFieldIsEdited] = useState(false);
	const [showToast, setShowToast] = useState(undefined);

	const [tokenRecaptchaRegister, setTokenRegister] = useState(null);

	useEffect(() => {
		if (!duplicityEmail) return;
		const { success, result } = duplicityEmail;
		if (success) {
			setIsEqualsEmail(result);
		}
	}, [duplicityEmail]);

	useEffect(() => {
		const infoUserLogin = JSON.parse(localStorage.getItem("INFO_USER_LOGIN"));
		const cdAccessToken = sessionStorage.getItem("cd_access_token");
		const isAbandonaded = sessionStorage.getItem("IS_ABANDONADED");

		if (infoUserLogin) {
			const { name, email } = infoUserLogin;
			const vlDoc = vlDocument.replace(/\.|-/g, "");
			setEmail(email);
			setNome(name);
			setDisableInput(true);
			updateOnboardField("email", email);
			updateOnboardField("name", name);
			verifyDuplicityEmail(email, vlDoc);
			setInputEmailValid(true);
			setInputNomeValid(true);
		}
		if (!cdAccessToken || isAbandonaded) history.push("/onboard/login");
	}, [vlDocument]);

	useEffect(() => {
		if (sessionStorage.getItem("DOC_TEMP")) sessionStorage.removeItem("DOC_TEMP");

		return () => {
			sessionStorage.removeItem("DOC_TEMP");
		};
	}, []);

	useEffect(() => {
		setIsEqualsEmail(undefined); //usado aqui para quando volta da tela de recover não aparecer a mensagem de erro
		let appflow = localStorage.getItem("appflow");

		if (appflow === "RECOVER" || !appflow) localStorage.setItem("appflow", "REGISTER");

		if (sessionStorage.getItem("GO_BACK")) sessionStorage.removeItem("GO_BACK");
	}, []);

	useEffect(() => {
		if (inputCpfValid && isEqualsEmail !== undefined) {
			updateOnboardField("email", email, false, emailFieldIsEdited);
		}
		// eslint-disable-next-line
	}, [inputCpfValid, isEqualsEmail]);

	useEffect(() => {
		if (
			resUpdateOnboardField.code &&
			["INVALID_DATE", "INVALID_MIN_AGE", "INVALID_MAX_AGE"].includes(
				resUpdateOnboardField.code
			)
		) {
			setBirthdayError(resUpdateOnboardField.message);
			setInputDataNascimentoValid(false);
			return;
		}
	}, [resUpdateOnboardField]);

	useEffect(() => {
		if ((isEqualsEmail || isUserRegistered) && !showToast) {
			setShowToast(true);
			const message = () => (
				<div>
					<span>
						Oba! Você já tem uma conta no TradeMap! Se não lembra sua
						senha,&nbsp;
						<Button
							variant="link"
							style={{
								padding: "0",
								textDecoration: "underline",
								fontWeight: "bold",
								color: "#FFF",
							}}
							onClick={() => changeRouter()}
						>
							recupere aqui!
						</Button>
					</span>
				</div>
			);
			toast.info(message, { autoClose: 50000 });
		}
		// eslint-disable-next-line
	}, [isEqualsEmail, isUserRegistered]);

	useEffect(() => {
		if (!confirmaSenha.length && !senha.length) return;

		if (confirmaSenha === senha) {
			updateOnboardField("password", confirmaSenha, false, true);
		}
		// eslint-disable-next-line
	}, [confirmaSenha, senha]);

	function validateEmail({ name, value }) {
		if (
			value.length > 2 &&
			regexEmail.test(String(value).toLowerCase().trim()) &&
			!regexWhithoutSpace.test(value)
		) {
			setInputEmailValid(true);
			setMessageErrorEmail("");
		} else {
			setInputEmailValid(false);
			setMessageErrorEmail("E-mail inválido");
		}
	}

	function validaCPF({ name, value }, is_edition) {
		const doc = value.replace(/\.|-/g, "");
		if (value.length >= 11) {
			setIsEqualsEmail(undefined); //usado aqui para o updateOnboardField do email ser chamado somente depois do verifyDuplicityEmail ter respondido
			const isValid = isCPFValid(value.replace(/\.|-/g, ""));
			if (isValid) {
				if (email.length) verifyDuplicityEmail(email, null);
				dispatch(userRegistered(doc));
				updateOnboardField(name, doc, "CPF", is_edition);
				setInputCpfValid(true);
				setVlDocument(cpfMask(vlDocument));
				sessionStorage.setItem("DOC_TEMP", doc);
			} else {
				setInputCpfValid(false);
			}
		} else {
			if (value.length > 1 && value.length < 11) {
				if (email.length) verifyDuplicityEmail(email, null);
				dispatch(userRegistered(doc));
				updateOnboardField(name, doc, "RNE", is_edition);
				setInputCpfValid(true);
				sessionStorage.setItem("DOC_TEMP", doc);
			} else {
				setInputCpfValid(false);
			}
		}
	}

	function validaDataNacimento({ name, value }) {
		let birthDay = value.split("/");
		birthDay = birthDay[2] + birthDay[1] + birthDay[0];

		const valueBirthDayFormat = birthDay.replace(/_/g, "");
		const birthday = moment(valueBirthDayFormat);
		const years = valueBirthDayFormat.substr(0, 4);

		const dateNow = new Date();
		const minimalYears = dateNow.getFullYear() - parseInt(years);

		const yearsUser = parseInt(valueBirthDayFormat.substr(0, 4));
		const monthUser = parseInt(valueBirthDayFormat.substr(4, 2));
		const dayUser = parseInt(valueBirthDayFormat.substr(6, 2));

		let minimalAge = dateNow.getFullYear() - yearsUser;

		const mounth = dateNow.getMonth() + 1 - monthUser;

		if (mounth < 0 || (mounth === 0 && dateNow.getDate() < dayUser)) minimalAge--;

		if (valueBirthDayFormat.length < 8 || minimalYears > 120 || !birthday.isValid()) {
			setInputDataNascimentoValid(false);
			return setBirthdayError("Data de nascimento inválida");
		}

		if (minimalAge < 14) {
			setInputDataNascimentoValid(false);
			return setBirthdayError("A idade mínima para utilizar o TradeMap é 14 anos");
		}

		setInputDataNascimentoValid(true);
		if (value !== dataForm.vl_birthdate && editable.vl_birthdate) {
			return updateOnboardField(name, value, false, true);
		}
		updateOnboardField(name, value);
	}

	function validaNome({ name, value }) {
		var regexName = /^[A-Za-zÀ-ú]{2,} [ A-Za-zÀ-ú]+$/g;

		if (regexName.test(value) && value.length) {
			if (value.split(" ").filter((item) => Boolean(item)).length > 1) {
				updateOnboardField(name, value.trim());
				setInputNomeValid(true);
			} else {
				setInputNomeValid(false);
				setNameError("Informe o seu nome completo");
			}
		} else {
			setNameError("Verifique seu nome");
			setInputNomeValid(false);
		}
	}

	function validaSenha(password) {
		/\s/g.test(password) && password.length ? setPasswordValid(false) : setPasswordValid(undefined);

		setPassSize(password.length >= 8);
		setPassNum(/\d/.test(password));
		setPassLow(/[a-z]/.test(password));
		setPassUpper(/[A-Z]/.test(password));
		setCaracterSpecial(/(?=.*\W)/.test(password));
		setSequentialPassword(/^(?=.*\d)(?!.*(?:012|123|234|345|456|567|678|789|890))/.test(password));
		setPasswordValid(passSize && passNum && passLow && passUpper && !/\s/g.test(password));
		setSenha(password);

		confirmaSenha.length
			? setInputConfirmaSenhaValid(confirmaSenha === password)
			: setInputConfirmaSenhaValid(undefined);
	}

	function validaConfirmaSenha(passConfimed) {
		if (senha === passConfimed) {
			setConfirmaSenha("");
			setInputConfirmaSenhaValid(true);
			updateOnboardField("password", passConfimed);
		} else {
			setConfirmaSenha(passConfimed);
			setInputConfirmaSenhaValid(false);
		}

		setConfirmaSenha(passConfimed);
	}

	const onboardGogogo = () => {
		dispatch(
			onboardingGogogoRequest(
				senha,
				isTermAccepted,
				"login_after_onboard",
				tokenRecaptchaRegister,
				adid
			)
		);
		const dataTerm = {
			idTerm: ID_TERM_TRADEMAP,
			token: senha,
		};

		sessionStorage.setItem("DATA_TERM", JSON.stringify(dataTerm));
	};

	const updateOnboardField = (field, value, extra = false, is_edition = false) => {
		dispatch(updateOnboardFieldRequest(field, value.trim(), extra, is_edition));
	};

	const verifyDuplicityEmail = (email, document = null) => {
		dispatch(verifyDuplicityEmailRequest(email, document));
	};

	const changeRouter = () => {
		sessionStorage.setItem("GO_BACK", "REGISTER");

		localStorage.setItem("appflow", "RECOVER");
		history.push("/onboard/welcome-register");
		HttpService.setAbandonedOnboardStatus();
	};

	return (
		<Main>
			<OnboardStep step={3} />
			<Container>
				<Content>
					<Form onSubmit={() => {}}>
						<Title>Criar uma conta</Title>
						<FormGroupInput>
							<Label>E-mail</Label>
							<InputText
								autoFocus={true}
								id="email"
								name="email"
								error={{
									value:
										inputEmailValid ===
										false,
								}}
								value={email}
								disabled={disableInput}
								onChange={(param) => {
									setEmail(param.target.value);
									setInputEmailValid(true);
								}}
								onFocus={(param) => {
									dispatch(
										setVerificatedEmailDuplicity(
											false
										)
									);
									setIsEqualsEmail(undefined);
									setDataForm({
										email: param.target
											.value,
									});
									param.target.value.length &&
										setEditable({
											email: true,
										});
								}}
								onBlur={(param) => {
									validateEmail(param.target);
									if (
										param.target
											.value !==
											dataForm.email &&
										editable.email
									) {
										setEmailFieldIsEdited(
											true
										);
									}
								}}
							/>

							{inputEmailValid === false ? (
								<MessageError>
									{messsageErrorEmail}
								</MessageError>
							) : null}
						</FormGroupInput>
						{/* <FormGroup> usar para ajuntar os inputs de de CPF e data de nascimento */}
						<FormGroupInput>
							<Label>CPF ou RNE</Label>
							<InputText
								id="CPF"
								name="cnpj_cpf"
								maxLength={14}
								value={vlDocument}
								error={{
									value:
										inputCpfValid ===
										false,
								}}
								width={12.5}
								onChange={(param) => {
									setVlDocument(
										param.target.value
									);
									setInputCpfValid(undefined);
								}}
								onFocus={(param) => {
									setDataForm({
										document: param
											.target
											.value,
									});
									param.target.value.length &&
										setEditable({
											document: true,
										});
								}}
								onBlur={(param) => {
									if (
										param.target
											.value !==
											dataForm.document &&
										editable.document
									) {
										return validaCPF(
											param.target,
											editable.document
										);
									}
									validaCPF(param.target);
								}}
							/>
							{inputCpfValid === false ? (
								<MessageError>
									Informe um CPF ou RNE válido
								</MessageError>
							) : null}
						</FormGroupInput>

						{/* </FormGroup> */}
						<FormGroupInput>
							<Label>Nome completo</Label>
							<InputText
								id="nome"
								name="name"
								type="text"
								error={{
									value:
										inputNomeValid ===
										false,
								}}
								value={nome}
								disabled={disableInput}
								onChange={(param) => {
									setNome(param.target.value);
									setInputNomeValid(undefined);
								}}
								onFocus={(param) => {
									setDataForm({
										fullName: param
											.target
											.value,
									});
									param.target.value.length &&
										setEditable({
											name: true,
										});
								}}
								onBlur={(param) => {
									validaNome(param.target);
									if (
										param.target
											.value !==
											dataForm.fullName &&
										editable.name
									) {
										updateOnboardField(
											param
												.target
												.name,
											param
												.target
												.value,
											false,
											true
										);
									}
								}}
							/>
							{inputNomeValid === false ? (
								<MessageError>{nameError}</MessageError>
							) : null}
						</FormGroupInput>
						<FormGroupInput>
							<Label>Data de nascimento</Label>
							<InputText
								inputMode="numeric"
								id="dataNascimento"
								name="vl_birthdate"
								mask="99/99/9999"
								value={dataNascimento}
								error={{
									value:
										inputDataNascimentoValid ===
										false,
								}}
								width={12.5}
								onChange={(param) => {
									setDataNascimento(
										param.target.value
									);
								}}
								onFocus={(param) => {
									setDataForm({
										vl_birthdate: param
											.target
											.value,
									});
									const format =
										param.target.value.replace(
											"__/__/____",
											""
										);
									format.length &&
										setEditable({
											vl_birthdate: true,
										});
								}}
								onBlur={(param) => {
									validaDataNacimento(
										param.target
									);
								}}
							/>
							{inputDataNascimentoValid === false && (
								<MessageError>
									{birthdayError}
								</MessageError>
							)}
						</FormGroupInput>
						<FormGroupInput>
							<Label>Senha</Label>
							<ContainerPassword>
								<InputText
									autoComplete="new-password"
									id="senha"
									name="senha"
									type={
										hidePassword
											? "password"
											: "text"
									}
									error={{
										value:
											passwordValid ===
											false,
									}}
									value={senha}
									onChange={(param) =>
										validaSenha(
											param
												.target
												.value
										)
									}
									onBlur={(param) =>
										validaSenha(
											param
												.target
												.value
										)
									}
								/>
								<PasswordEye
									error={false}
									onClick={() =>
										setHidePassword(
											!hidePassword
										)
									}
								>
									{hidePassword ? (
										<Visibility
											width={18}
										/>
									) : (
										<VisibilityOff
											width={18}
										/>
									)}
								</PasswordEye>
							</ContainerPassword>
							{passwordValid === false ? (
								<MessageError>
									Não use espaço em branco na
									sua senha.
								</MessageError>
							) : null}
						</FormGroupInput>
						<ContainerRequirements>
							<FormGroupLine>
								<Group>
									<img
										src={
											passSize
												? checkIcon
												: alertIcon
										}
										alt="Check Icon"
									/>
									<span>8 caracteres</span>
								</Group>
							</FormGroupLine>
							<FormGroupLine>
								<Group>
									<img
										src={
											passLow
												? checkIcon
												: alertIcon
										}
										alt="Check Icon"
									/>
									<span>1 letra minúscula</span>
								</Group>
							</FormGroupLine>
							<FormGroupLine>
								<Group>
									<img
										src={
											passUpper
												? checkIcon
												: alertIcon
										}
										alt="Check Icon"
									/>
									<span>1 letra maiúscula</span>
								</Group>
							</FormGroupLine>
							<FormGroupLine>
								<Group>
									<img
										src={
											passNum
												? checkIcon
												: alertIcon
										}
										alt="Check Icon"
									/>
									<span>1 número</span>
								</Group>
							</FormGroupLine>
							<FormGroupLine>
								<Group>
									<img
										src={
											caracterSpecial
												? checkIcon
												: alertIcon
										}
										alt="Check Icon"
									/>
									<span>
										1 caracter especial
									</span>
								</Group>
							</FormGroupLine>
							<FormGroupLine>
								<Group>
									<img
										src={
											sequentialPassword
												? checkIcon
												: alertIcon
										}
										alt="Check Icon"
									/>
									<span>
										A senha não pode ter
										sequência númerica.
										Ex: 123, 234.
									</span>
								</Group>
							</FormGroupLine>
						</ContainerRequirements>
						<FormGroupInput>
							<Label>Confirme sua senha </Label>
							<ContainerPassword>
								<InputText
									id="paswordConfirmed"
									name="confirmaSenha"
									type={
										hidePasswordConfirmed
											? "password"
											: "text"
									}
									value={confirmaSenha}
									error={{
										value:
											inputConfirmaSenhaValid ===
											false,
									}}
									onFocus={(param) => {
										setDataForm({
											password: param
												.target
												.value,
										});
										param.target.value
											.length &&
											setEditable(
												{
													password: true,
												}
											);
									}}
									onChange={(param) =>
										validaConfirmaSenha(
											param
												.target
												.value
										)
									}
									onBlur={(param) => {
										if (
											param
												.target
												.value !==
												dataForm.password &&
											editable.password
										) {
											updateOnboardField(
												"password",
												param
													.target
													.value,
												false,
												true
											);
										}
									}}
								/>
								<PasswordEye
									error={
										inputConfirmaSenhaValid ===
										false
									}
									onClick={() =>
										setHidePasswordConfirmed(
											!hidePasswordConfirmed
										)
									}
								>
									{hidePasswordConfirmed ? (
										<Visibility
											width={18}
										/>
									) : (
										<VisibilityOff
											width={18}
										/>
									)}
								</PasswordEye>
							</ContainerPassword>
							{inputConfirmaSenhaValid === false ? (
								<MessageError>
									As senhas precisam ser iguais
								</MessageError>
							) : null}
						</FormGroupInput>
						<SubmitButton
							onClick={() => onboardGogogo()}
							disabled={
								!inputCpfValid ||
								!inputDataNascimentoValid ||
								!inputNomeValid ||
								!inputEmailValid ||
								!inputConfirmaSenhaValid ||
								!passwordValid ||
								!passSize ||
								!passNum ||
								!passUpper ||
								!passLow ||
								!caracterSpecial ||
								!sequentialPassword ||
								loading
							}
						>
							{loading ? (
								<CircularProgress
									style={{
										width: "20px",
										height: "20px",
										color: "#13141B",
									}}
								/>
							) : (
								"Criar conta"
							)}
						</SubmitButton>
					</Form>
				</Content>
			</Container>
			<RecaptchaInvisible token={setTokenRegister} change={(param) => {}} />
		</Main>
	);
}
